export const normalizeSelectionItems = (items) => {
  return [].concat(items).map((item) => ({
    type:
      item.type === 'search-result' || item.type === 'favorite'
        ? item.resource_type
        : item.type,
    id: item.id
  }));
};
